/** * * Asynchronously loads the component for
Accessibility
* */ import { lazyLoad } from "utils/loadable";
export const Accessibility = lazyLoad(
  () => import("./index"),
  (module) => module.Accessibility
);
